import script from "./EdgePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EdgePanel.vue?vue&type=script&setup=true&lang=js"

import "./EdgePanel.vue?vue&type=style&index=0&id=afa82078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa82078"]])

export default __exports__